
// const API_BASE = "https://nuvvygroup.com/api";
// export const MEDIA_BASE_URL = "https://nuvvygroup.com"; // base for media (no trailing slash)

const API_BASE = "https://nuvvygroup.com/api";
export const MEDIA_BASE_URL = "https://nuvvygroup.com"; // base for media (no trailing slash)

// set to true أثناء التطوير لعرض سجلات debug في الكونسل
const DEBUG_IMAGES = false;
/**
 * Normalize and resolve image src to a full URL.
 * - If src starts with http(s) returns as-is
 * - If src starts with '/' =>MEDIA_BASE_URL + src
 * - If src is relative (no leading slash) => MEDIA_BASE_URL + '/' + src
 * - If empty => '/placeholder.png' (app public)
 */

export function resolveImageUrl(src) {
	// accept objects sometimes passed
	const raw = src && typeof src === "object" ? (src.image || src.url || "") : src;
	if (!raw) return "/placeholder.png";

	const s = String(raw).trim();

	// already absolute
	if (/^https?:\/\//i.test(s)) {
		if (DEBUG_IMAGES) console.debug("resolveImageUrl - absolute", { raw, final: s });
		return s;
	}

	// remove accidental leading/trailing spaces and multiple slashes
	const base = String(MEDIA_BASE_URL).replace(/\/+$/, "");
	const path = s.replace(/^\/+/, ""); // remove leading slashes

	const final = `${base}/${encodeURI(path)}`;
	if (DEBUG_IMAGES) console.debug("resolveImageUrl - resolved", { raw, final });
	return final;
}

/**
 * Compatibility helper used in older code: tries to use resolveImageUrl,
 * but allows passing already-resolved url(s).
 */
export function getImageUrl(src) {
	try {
		return resolveImageUrl(src);
	} catch (e) {
		if (DEBUG_IMAGES) console.error("getImageUrl error", e, src);
		return "/placeholder.png";
	}
}

export default { MEDIA_BASE_URL, resolveImageUrl, getImageUrl };
